import { CmsError } from '@/http/CmsError';
import Vue, { PluginObject, VueConstructor } from 'vue';

export function errorLog(this: Vue, error: any) {
    if (error instanceof CmsError) {
        console.error(error, '\n', error.details);
    } else {
        console.error(error);
    }
}

export const ErrorLogPlugin: PluginObject<Vue> = {
    install(Vue: VueConstructor) {
        Vue.prototype.$errorLog = errorLog;
    },
};
